import { Slider } from "@comparaonline/ui-offer-slider";
import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

import "slick-carousel/slick/slick.css";
import { getSliderProps } from "./sliderConfig";

export const styles: StyleRulesCallback = ({ spacing: { unit } }) => ({
  slideTrackContainer: {
    "& .slick-list": {
      "& .slick-track": {
        "& .slick-slide": {
          "& > *": {
            display: "flex",
            marginLeft: `${unit * 2}px`,
            padding: `${unit}px 0`
          },
          display: "flex",
          height: "auto"
        },
        display: "flex",
        overflow: "hidden"
      }
    },
    "-webkit-overflow-scrolling": "touch"
  }
});

const SliderBase: React.FC<WithStyles<typeof styles, true>> = ({ classes, children, theme }) => (
  <div className={classes.slideTrackContainer}>
    <Slider {...getSliderProps(theme)}>{children}</Slider>
  </div>
);

export const SliderDesktop = withStyles(styles, { withTheme: true })(SliderBase);
